export default "__VITE_ASSET__ec4c56f2__"